import $ from "jquery";

const init_responsive_embed = () => {
    $(document).ready(function() {
        $('.content-noma iframe, .content-noma object,.content-noma  embed,.content-noma  video').each(function() {
            $(this).wrap("<div class='ratio ratio-16x9'/>");
        });
    });
}


export {init_responsive_embed}